module.exports = __webpack_public_path__ + "img/icon_substitution.f1c8c722.svg";